import { put, call, takeLatest } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { ChatHistoryType } from 'domain/types/chatHistory.type';
import { fetchChatHistorySuccessAction, fetchChatHistoryFailureAction } from 'domain/actions/chatHistory.action';
import { showLoading, hideLoading } from 'domain/actions/loading.action';
import { getChatHistory } from 'service/chatHistory/chatHistory.service';
import { ChatHistoryResponse } from 'model/chatHistory/chatHistory.response';
import { ChatHistoryRequest } from 'model/chatHistory/chatHistory.request';

function* fetchChatHistorySaga(action: any): SagaIterator {
  try {
    yield put(showLoading());
    const params: ChatHistoryRequest = action.payload.params;
    const response: ChatHistoryResponse = yield call(getChatHistory, params);
    yield put(fetchChatHistorySuccessAction(response));
  } catch (error: any) {
    yield put(fetchChatHistoryFailureAction(error?.message || 'Failed to fetch chat history'));
  } finally {
    yield put(hideLoading());
  }
}

export function* chatHistorySaga(): SagaIterator {
  yield takeLatest(ChatHistoryType.FETCH_CHAT_HISTORY_REQUEST, fetchChatHistorySaga);
}
